import dayjs from "dayjs";
import { factoryProcessTemplatesFields } from "../Constantes/factoryProcessFields";


export function parseJwtToken () {
    let token = localStorage.getItem("apoloCMRTK");
    if ( token != null) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }

    return null;
   
};

export function isUserInRole(role, userRoles) {
    // let user = parseJwtToken();
    if (userRoles) {
        let roles = userRoles.map(r=> r.roleName || r);
        return roles.includes(role);
    }
    return false;
}

export function isUserInRoles(allowedRoles, userRoles) {
    // let user = parseJwtToken();
    if (userRoles) {
        let roles = userRoles.map(r=> r.roleName || r);
        return allowedRoles.some(ar=> ar === ("*") || roles.includes(ar));
    }
    return false;
}

export function _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}


export function convertToLocalTime(UTCdate, format){
const date= dayjs.utc(UTCdate);
const timezone= dayjs.tz.guess()
const result= dayjs(date).tz(timezone).format(format?"DD/MM/YYYY HH:mm":null)
if(result === "Invalid Date"){
    return null}
return result

}

export function convertToUTC(localDate){
    const date = new Date(localDate)
    const result= dayjs.utc(date).format();
    if(result === "Invalid Date"){return null}
return result
    
}
export function getTimeZone(){
    return dayjs.tz.guess();
}
export function getUTCOffset(){
    //offset in minutes
    const utcOffset = dayjs().utcOffset();

    return Math.round(utcOffset/60);
}

export function deleteStrangeCharacters(text){
    return text.replace(/[^(\u0000-\u007F \u0080-\u00FF \u0100-\u017F \u2000-\u206F \u2070-\u209F \u20A0-\u20CF)]/gi, "")
}

export function urlToB64(caseId){
let url;
const baseUrl = window.location.origin
const urlParam = `/?cod_cliente=${caseId}&callid=@callid@`
url = baseUrl + urlParam;
const toB64 = btoa(url)
return toB64
}

export function getClaimsRequestFormData(dataDoc, template){
    const data = {};
    const fields = factoryProcessTemplatesFields?.filter(x => (x.templateType === template && x.isFormData) || (!x.templateType && x.isFormData) || (Array.isArray(x) && x.every(y => y.templateType === template && y.isFormData)))
    fields.forEach(x => {
        if(Array.isArray(x)){
            x.forEach(y =>{
                data[y.value] = dataDoc[y.value];
            })
        }else{
            data[x.value] = dataDoc[x.value];
        }
    })
    return data;
}


export function validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

export function validateCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, ''); // Remove non-numeric characters

  if (cnpj.length !== 14) return false;

  // Check for invalid sequences like "00000000000000"
  if (/^(\d)\1+$/.test(cnpj)) return false;

  const calculateCheckDigit = (cnpj, length) => {
    const weights = length === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < length; i++) {
      sum += parseInt(cnpj[i]) * weights[i];
    }

    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const firstCheckDigit = calculateCheckDigit(cnpj, 12);
  const secondCheckDigit = calculateCheckDigit(cnpj, 13);

  return firstCheckDigit === parseInt(cnpj[12]) && secondCheckDigit === parseInt(cnpj[13]);
}